// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SharedSearchBar_overlay__QmuDU"};